import React from "react";
import { GRAY, oxoColors } from "../../../../constants/enums";
import useFirestoreLiveDocument from "../../../../utils/hooks/useFirestoreLiveDocument";
import {
  CardAnswerStatsSchema,
  FirestoreCollection
} from "../../../../constants/firestore_schema";
import OXOBarChart from "./OXOBarChart";

export default function QuestionChart({
  cardId,
  colorScale = [oxoColors.O, oxoColors.DUNNO, oxoColors.X]
}: {
  cardId: string;
  colorScale?: string[];
}) {
  const [cardAnswerStats] = useFirestoreLiveDocument<CardAnswerStatsSchema>(
    FirestoreCollection.CARD_ANSWER_STATS,
    cardId
  );

  if (!cardAnswerStats) {
    return null; // cannot be the case.
  }

  return (
    <div>
      <div style={{ paddingLeft: 40, paddingRight: 40 }}>
        <OXOBarChart
          cardAnswerStats={cardAnswerStats}
          colorScale={colorScale}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingLeft: 40,
          paddingRight: 40,
          color: GRAY
        }}
      >
        <div>
          <div
            style={{
              textAlign: "right",
              color: GRAY,
              display: "flex"
            }}
          >
            응답 {cardAnswerStats.count}
          </div>
        </div>
      </div>
    </div>
  );
}
